/** Types transverses du contrat /api/v1 (BetaOrderCaptureBack/app/common/). */

export interface PageMetadata {
  total_count: number;
  page: number;
  page_size: number;
  /** Nombre d'éléments dans cette page. */
  total_found: number;
}

/** Enveloppe de pagination commune (app/common/pagination.py). */
export interface Page<T> {
  metadata: PageMetadata;
  data: T[];
}

/**
 * Feuille image du contrat : `key` = clé S3 brute (stable, à renvoyer à
 * l'écriture), `url` = URL présignée (affichage, ~15 min — ne jamais persister).
 * Le front affiche `.url` et renvoie `.key` ; ni lui ni le back ne parsent d'URL.
 */
export interface ImageRef {
  key: string;
  url: string;
}

/** Champ i18n renvoyé en dict ({fr: "...", en: "..."} ou parfois string brut). */
export type I18nText = Record<string, string> | string | null | undefined;

/**
 * Ordre de repli quand la langue demandée manque. Explicite et DÉTERMINISTE :
 * l'ancien `Object.values(value)[0]` dépendait de l'ordre d'insertion des clés JSON,
 * si bien qu'une référence Ralawise (`{en: "Hoodie"}`, sans `fr`) pouvait afficher de
 * l'anglais sur une page française sans que rien ne le signale.
 */
const FALLBACK_LANGS = ['fr', 'en'] as const;

export function i18nField(value: I18nText, lang = 'fr'): string {
  if (!value) return '';
  if (typeof value === 'string') return value;

  const chain = [lang, ...FALLBACK_LANGS];
  for (const l of chain) {
    const hit = value[l];
    if (hit) return hit;
  }
  // Dernier recours : une langue non prévue par le contrat vaut mieux que du vide.
  return Object.values(value).find(Boolean) ?? '';
}
